import { NvTableCellProps } from 'shared/components/nv-table';
import { MentoringProgramEnrollment } from 'redux/schemas/models/mentoring-program-enrollments';

export enum ColumnID {
  NAME = 'name',
  STATUS = 'status',
  ASSIGNED = 'assigned',
  AVAILABILITY = 'availability',
  OPTIONS = 'options',
}

export type CellProps = NvTableCellProps<MentoringProgramEnrollment>;
